import { Component, OnInit } from '@angular/core';

interface data {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-opsremittances',
  templateUrl: './opsremittances.component.html',
  styleUrls: ['./opsremittances.component.css']
})
export class OpsremittancesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  public ShowFilters: boolean = true;
  public buttonName: any = 'Show Filters';
  vendorId: any;

  toggle() {
    this.ShowFilters = !this.ShowFilters;
    if (this.ShowFilters)
      this.buttonName = "Hide Filters";
    else
      this.buttonName = "Show Filters";
  }

  custs: data[] = [
    { value: 'FREEDOM-1', viewValue: 'FREEDOM' },
    { value: 'XOME-2', viewValue: 'XOME' },
    { value: 'PROTECK-3', viewValue: 'PROTECK' },
    { value: 'BK EMPOWER-4', viewValue: 'BK EMPOWER' },
    { value: 'FREEDOM XPANSE-5', viewValue: 'FREEDOM XPANSE' },
  ];

  vendor: data[] = [
    { value: 'First-1', viewValue: 'First' },
    { value: 'Second-1', viewValue: 'Second' },
    { value: 'Third-1', viewValue: 'Third' },
  ];

  intVendor: data[] = [
    { value: 'First-1', viewValue: 'First' },
    { value: 'Second-1', viewValue: 'Second' },
    { value: 'Third-1', viewValue: 'Third' },
  ];

  lendor: data[] = [
    { value: 'First-1', viewValue: 'First' },
    { value: 'Second-1', viewValue: 'Second' },
    { value: 'Third-1', viewValue: 'Third' },
  ];


}
